export type TTaggableContact = {
  tags?: Array<string | null | undefined> | null
  accounts?: Array<{ tag?: string | null }> | null
}

// Sub-types worth a badge of their own: the qualifier is the useful part, so `ContractorPainter`
// reads as "Painter". `Agent` is the API's name for what the UI calls the Team.
const TAG_LABELS: Record<string, string> = {
  Agent: 'Team',
  ContractorBinCleaner: 'Bin Cleaner',
  ContractorCarpetCleaning: 'Carpet Cleaning',
  ContractorPainter: 'Painter',
  SupplierDomestic: 'Domestic',
  SupplierDstv: 'DSTV',
  SupplierInternet: 'Internet',
  SupplierTelephone: 'Telephone',
}

// Sub-types that aren't: whoever is scanning the list only cares that the contact is a body
// corporate or a municipality, so `BodyCorporateRates` and `MunicipalityElectricity` collapse onto
// their parent rather than spelling out which charge they cover.
const CONDENSED_TAG_PREFIXES: Array<[string, string]> = [
  ['BodyCorporate', 'Body Corporate'],
  ['Municipality', 'Municipality'],
]

// Only All still shows the tag badges. Every other tab either has an Outstanding column in that
// slot or, in Team's case, is a single type of contact and so has nothing to badge.
const TAG_COLUMN_TABS: string[] = ['all']

/** Whether a tab shows the tag badge column. Mutually exclusive with `hasOutstandingColumn`. */
export const hasTagsColumn = (tabKey: string): boolean => TAG_COLUMN_TABS.includes(tabKey)

export const getContactTagLabel = (tag: string): string =>
  TAG_LABELS[tag] ?? CONDENSED_TAG_PREFIXES.find(([prefix]) => tag.startsWith(prefix))?.[1] ?? tag

export const getContactTagLabels = ({ tags, accounts }: TTaggableContact): string[] => {
  const rawTags = [...(accounts ?? []).map(account => account?.tag), ...(tags ?? [])]

  return [...new Set(rawTags.filter((tag): tag is string => Boolean(tag)).map(getContactTagLabel))].sort((a, b) =>
    a.localeCompare(b),
  )
}
